import ClosestCircleSection from "./closestCircleSection";
import Localization from "../../../../localization";
import { Button } from "../../../../components";
import GroupsSection from "./groupsSection";
import useViewModel from "../../viewModel";
import "react18-json-view/src/style.css";
import Options from "./options";

const Collaborators = ({ progress = "", activated, close = () => {} }) => {
  const { updateProgress, device } = useViewModel();

  return (
    <div>
      <ClosestCircleSection />
      <GroupsSection progress={progress} className="m-20-t" />
      {device.supportsSignals && (
        <Options progress={progress} className="m-20-t" />
      )}
      <Button
        type="primary"
        className="m-30-t"
        title={Localization.general.done}
        onClick={async () => {
          if (!activated) await updateProgress(progress);
          close();
        }}
      />
    </div>
  );
};

export default Collaborators;
